import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import Tag from '@/atoms/Tag/Tag'

function CreatorTag() {
  const { t } = useTranslation('global')
  const { push, query } = useRouter()
  const { creator, ...params } = query

  const remove = () => push({ query: params }, undefined, { shallow: true })

  if (typeof creator !== 'string') return null

  const text = `${t('creator')}: ${creator}`

  return <Tag value={text} onRemove={remove} />
}

export default CreatorTag
